export const debitNotes = {
	title: "Notas de Débito",
	filename: "notas-de-debito",
	table: {
		serialNumber: "Número",
		issueDate: "Fecha de emisión",
		period: "Período",
		status: "Estado",
		value: "Valor",
		generatedAs: "Generado como",
		pdf: "PDF",
		noAttachments: "Sin anexos",
		attachments: "Anexos",
	},
	status: {
		created: "Creado",
		generated: "Generado",
		cancelled: "Cancelado",
	},
	generated: {
		automatic: "Automático",
		manually: "Manualmente",
	},
	emptyText: "No hay nada que mostrar para el período seleccionado",
};
